import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import './index.css';
import './App.css';
import App from './App';

// Initialize Google Analytics
ReactGA.initialize('G-3EZWTF5RL1');

// Track referrer and embed context for iframe usage
const trackEmbedContext = () => {
  const referrer = document.referrer;
  const isIframe = window.self !== window.top;
  
  // Determine embed source
  let embedSource = 'Direct';
  if (referrer) {
    if (referrer.includes('pearson.com')) {
      embedSource = 'Pearson Website';
    } else if (referrer.includes('support.pearson.com')) {
      embedSource = 'Pearson Knowledge Base';
    } else if (referrer.includes('qualifications.pearson.com')) {
      embedSource = 'Pearson Qualifications';
    } else {
      embedSource = 'External Referrer';
    }
  }
  
  // Track initial load context
  ReactGA.event({
    category: 'Embed Context',
    action: 'Calculator Load',
    label: embedSource,
    custom_parameters: {
      is_iframe: isIframe,
      referrer_domain: referrer ? new URL(referrer).hostname : 'none',
      embed_source: embedSource
    }
  });
  
  // Track iframe vs direct usage
  ReactGA.event({
    category: 'Usage Context',
    action: isIframe ? 'Iframe Load' : 'Direct Load',
    label: embedSource
  });
};

// Execute tracking after GA initialization
trackEmbedContext();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 